import { Field } from 'formik';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Text } from '@summer/ui-components/src';

import FilesUpload from 'components/shared/FilesUpload/FilesUpload';
import {
  clearFilesErrors,
  deleteFile,
  removeFileWithError,
  uploadFileV4,
} from 'redux/actions/fileCollections.actions';

const SlcFileUpload = ({
  fileCollection,
  collection,
  value,
  setFieldValue,
  setFieldTouched,
  name,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    setFieldTouched(name, false);
  }, [name, setFieldTouched]);

  useEffect(() => {
    // only gets called once the update has been confirmed in redux
    setFieldValue(name, fileCollection);
    setFieldTouched(name, true);
  }, [setFieldValue, setFieldTouched, name, fileCollection]);

  return (
    <Field name={name}>
      {({ meta }) => {
        return (
          <>
            <FilesUpload
              clearFilesErrors={clearFilesErrors}
              handleFileUpload={file => {
                dispatch(uploadFileV4({ collection, file }));
              }}
              handleDeleteFile={fileId => {
                dispatch(deleteFile({ collection, fileId }));
              }}
              handleRemoveFileWithError={fileName => {
                dispatch(removeFileWithError({ collection, fileName }));
              }}
              fileList={value}
              collectionName={collection}
              dropZoneHeight="104px"
              dropZoneOnTop={true}
            />
            <Text size="small" color="error">
              {meta.touched && meta.error}
            </Text>
          </>
        );
      }}
    </Field>
  );
};

export default SlcFileUpload;
